
/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 12/29/15.
 */
'use strict';
angular.module('prism-ui.components.navigation').service('SidebarService',
     function ($location, PaginationService, BreadcrumbService, PermissionsService)  {
        let self = this;
        let currentSelectedItem;

        let defaultSessionData = {
            previousLocation: '',
            paginationData: {},
            permissions: null
        };

        self.editService = null;

        let navigationMap = {

            //===========//
            // DASHBOARD //
            //===========//

            'workflows': {
                label: 'Workflows',
                defaultLocation: 'dashboard/workflows',
                viewState: 'DASHBOARD_WORKFLOW_VIEW',
                sessionData: angular.copy(defaultSessionData)
            },
            'queues': {
                label: 'Queues',
                defaultLocation: '/dashboard/queues/summary',
                viewState: 'DASHBOARD_QUEUE_VIEW',
                sessionData: angular.copy(defaultSessionData)
            },
            'reports': {
                label: 'Reports',
                defaultLocation: '/dashboard/report/partnerdeliveryreport',
                viewState: 'DASHBOARD_REPORT_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },
            'calendars': {
                label: 'Calendars',
                defaultLocation: '/dashboard/calendars',
                viewState: 'DASHBOARD_CALENDAR_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },
            'offCyclePlanners': {
                label: 'Off Cycle Planners',
                defaultLocation: '/dashboard/offCyclePlanners',
                viewState: 'DASHBOARD_OFF_CYCLE_PLANNERS_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },
            'checkin': {
                label: 'Package Check-in',
                defaultLocation: '/dashboard/checkin',

                //
                // 2018-Jan-18 / ABC-9319
                //
                // The permission state for check-in, for now,
                // will be the same as for checkout, a.k.a. "batch
                // modify".
                //

                viewState: 'PACKAGE_BATCH_MODIFY_METADATA_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData),
            },
            'metrics': {
                label: 'Metrics',
                defaultLocation: '/dashboard/metrics',
                sessionData: angular.copy(defaultSessionData)
            },

            //======//
            // META //
            //======//

            'networks': {
                label: 'Networks',
                defaultLocation: '/meta/networks/search',
                viewState: 'NETWORK_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },
            'adsAndPreRolls': {
                label: 'Ads/PreRolls',
                defaultLocation: '/meta/adsAndPreRolls/search',
                viewState: 'ADS_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },
            'series': {
                label: 'Series',
                defaultLocation: '/meta/series/search',
                viewState: 'SERIES_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },
            'movies': {
                label: 'Movies',
                defaultLocation: '/meta/movies/search',
                viewState: 'MOVIE_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },
            'collaborators': {
                label: 'Collaborators',
                defaultLocation: '/meta/collaborators/search',
                viewState: 'COLLABORATOR_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },
            'mvpd': {
                label: 'MVPD',
                defaultLocation: '/meta/mvpd/search',
                viewState: 'MVPD_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },


            //========//
            // SYSTEM //
            //========//

            'partners': {
                label: 'Partners',
                defaultLocation: '/system/partners/search',
                viewState: 'SYSTEM_PARTNERS_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },
            'users': {
                label: 'Users',
                defaultLocation: '/system/users/search',
                sessionData: angular.copy(defaultSessionData)
            },
            'groups': {
                label: 'Groups',
                defaultLocation: '/system/groups/search',
                sessionData: angular.copy(defaultSessionData)
            },
            'properties': {
                label: 'properties',
                defaultLocation: '/system/properties/search',
                sessionData: angular.copy(defaultSessionData)
            },
            'contacts': {
                label: 'Contacts',
                defaultLocation: '/system/contacts/search',
                sessionData: angular.copy(defaultSessionData)
            },
            'metadataItems': {
                label: 'Metadata Items',
                defaultLocation: '/system/metadataItems/package',
                sessionData: angular.copy(defaultSessionData)
            },
            'livefeeds': {
                label: 'Live Feeds',
                defaultLocation: '/system/livefeeds/search',
                viewState: 'DEBUG_SYSTEM_OPERATIONS_VIEW_STATE',
                sessionData: angular.copy(defaultSessionData)
            },
            'fileSystems': {
                label: 'File Systems',
                defaultLocation: '/system/fileSystems/search',
                sessionData: angular.copy(defaultSessionData)
            },
            'templates': {
                label: 'templates',
                defaultLocation: '/system/templates/search',
                sessionData: angular.copy(defaultSessionData)
            },
            'aggregation': {
                label: 'Aggregation',
                defaultLocation: '/system/aggregation/setup',
                sessionData: angular.copy(defaultSessionData)
            },
            'execServers': {
                label: 'Exec Servers',
                defaultLocation: '/system/execServers',
                sessionData: angular.copy(defaultSessionData)
            },
            'packageNotifications': {
                label: 'Package Notifications',
                defaultLocation: '/system/packageNotifications/search',
                sessionData: angular.copy(defaultSessionData)
            },


            //==========//
            // PACKAGES //
            //==========//

            'packages': {
                label: 'Package',
                defaultLocation: '/packages',
                sessionData: angular.copy(defaultSessionData)
            },
        };

        currentSelectedItem = '';

        self.setNavPermissions =  () => {
            angular.forEach(navigationMap,  (navItem) => {
                if (navItem.viewState && !navItem.sessionData.permissions) {
                    PermissionsService.getPermissionsForViewState(navItem.viewState).then( (viewState) => {
                        navItem.sessionData.permissions = {
                            canRead: PermissionsService.hasReadPermission(viewState.permission),
                            canWrite: PermissionsService.hasWritePermission(viewState.permission),
                            canExecute: PermissionsService.hasExecutePermission(viewState.permission)
                        };
                    });
                }
            });
        };

        self.ignoreNavUpdates = false;

        self.overrideNavigationProperty =  (sidebarSection, overrideProp, overrideVal) => {
            let navItem = navigationMap[sidebarSection];
            navItem.sessionData[overrideProp] = overrideVal;
        };

        self.setSelectedItem =  (item) => {
            if (currentSelectedItem !== item) {
                if (currentSelectedItem && !self.ignoreNavUpdates) {
                    BreadcrumbService.clearBreadcrumbs();
                    let current = navigationMap[currentSelectedItem];
                    let newSelection = navigationMap[item];
                    current.sessionData.previousLocation = $location.url();
                    current.sessionData.paginationData = PaginationService.saveCurrentValues();
                    if (newSelection.sessionData.previousLocation) {
                        PaginationService.restoreValues(newSelection.sessionData.paginationData);
                        $location.url(newSelection.sessionData.previousLocation);
                    } else {
                        PaginationService.resetToDefaultValues();
                        $location.url(newSelection.defaultLocation);
                    }
                }
                currentSelectedItem = item;
            }
        };

        self.getSelectedItem =  () => {
            return currentSelectedItem;
        };

        self.userHasPermissionForSidebarItem =  (item) => {
            return !!navigationMap[item].sessionData.permissions &&
                navigationMap[item].sessionData.permissions.canRead;
        };

        self.userHasRWPermissionForSidebarItem =  (item) => {
            return !!navigationMap[item].sessionData.permissions &&
                navigationMap[item].sessionData.permissions.canRead &&
                navigationMap[item].sessionData.permissions.canWrite;
        };

        self.clearSessionData =  () => {
            currentSelectedItem = '';
            self.ignoreNavUpdates = false;
            angular.forEach(navigationMap,  (navItem) => {
                navItem.sessionData = angular.copy(defaultSessionData);
            });
        };

        self.goToUrl =  (goToUrl, destinationBase, previousBase) => {
            self.overrideNavigationProperty(destinationBase, 'previousLocation', goToUrl);
            self.overrideNavigationProperty(destinationBase, 'paginationData', {});
            self.overrideNavigationProperty(previousBase, 'previousLocation', $location.url());
            BreadcrumbService.clearBreadcrumbs();
            self.ignoreNavUpdates = true;
            $location.url(goToUrl);
        };
    });
